<i18n lang="yaml">
ja:
  home: ホーム
en:
  home: Home
</i18n>

<template>
  <nav
    class="ho-admin-breadcrumb"
    aria-label="breadcrumb"
  >
    <ol class="list">
      <li
        v-for="(crumb, index) in items"
        :key="index"
        class="item"
        :class="{ '-current': index === items.length - 1 }"
        :aria-current="index === items.length - 1 ? 'page' : undefined"
      >
        <NuxtLink
          v-if="crumb.to && index !== items.length - 1"
          :to="crumb.to"
          class="link"
        >
          {{ crumb.label }}
        </NuxtLink>
        <span
          v-else
          class="text"
        >
          {{ crumb.label }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script lang="ts">
export type BreadcrumbItem = {
  label: string
  to?: string
}

export default defineComponent({
  name: 'HoAdminBreadcrumb',
})
</script>

<script setup lang="ts">
withDefaults(
  defineProps<{
    items: BreadcrumbItem[]
  }>(),
  {},
)
</script>

<style lang="scss" scoped>
@use '#base/app/assets/styles/variables' as v;

.ho-admin-breadcrumb {
  > .list {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;

    padding: 0;

    list-style: none;

    > .item {
      display: flex;
      align-items: center;
      font-size: 13px;
      color: v.$admin-text-secondary;

      &:not(:last-child)::after {
        content: '/';
        margin-left: 4px;
        color: v.$admin-text-secondary;
        opacity: 0.6;
      }

      > .link {
        color: v.$admin-accent;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }

      &.-current > .text {
        font-weight: 500;
        color: v.$admin-text-primary;
      }
    }
  }
}
</style>
